module.exports = __webpack_public_path__ + "img/grupo-smart-black.4e48ae46.png";